/* eslint-disable max-len */
import {post, get} from 'common/utils/http';

export const sendMail = (payload) => post('api/v1/send-email-digest', {usersData: payload.payload});

export const getChampions = () => get('api/v1/getChampionsFromGainsight');
